var ServiceOtherTypes = {
  CATALOG: 0,
  VOLUMES: 1,
  PODS: 2
};

module.exports = ServiceOtherTypes;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/ServiceOtherTypes.js